import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useConfig } from "./hooks/useConfig";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CookieConsent } from "react-wavecoder-components";

import theme from "./theme";
import Home from "./home/Home";
import './App.css';
import { useConsentChange, triggerConsentChange } from './hooks/useConsentChange';
import { BlogWrapper } from './BlogWrapper';

const AppContent: React.FC = () => {
  const { config, loaded: configLoaded } = useConfig();
  const [homeLoaded, setHomeLoaded] = useState(false);
  const location = useLocation();
  const loaded = configLoaded && homeLoaded;

  useEffect(() => {
    if (location.pathname !== '/') {
      setHomeLoaded(false);
    }
  }, [location.pathname]);

  return (
    <Routes>
      <Route 
        path="/" 
        element={
          <Home 
            key={location.pathname}
            loaded={loaded} 
            setLoaded={setHomeLoaded} 
          />
        } 
      />
      <Route
        path="/blog/*"
        element={config ? <BlogWrapper config={config} /> : null}
      />
    </Routes>
  );
};

const App: React.FC = () => {
  useConsentChange();

  const handleCookieAccept = () => {
    triggerConsentChange();
  };

  const handleCookieDecline = () => {
    triggerConsentChange();
  };
  
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Router>
          <AppContent />
        </Router>
        <CookieConsent 
          onAccept={handleCookieAccept}
          onDecline={handleCookieDecline}
        />
      </div>
    </ThemeProvider>
  );
}

export default App;